<template>
    <container-wrapper :widget="widget" :isDesign="isDesign" :widgetList="widgetList"
        :class="{ 'grid-container-design': !!isDesign }" :indexOfParentList="indexOfParentList">
        <a-row v-bind="layoutProps" class="grid-container" @click.stop="selectWidget(widget)">
            <template v-for="(colWidget, colIdx) in widget.widgetList" :key="colIdx">
                <grid-col-widget :widget="colWidget" :widgetList="widget.widgetList" :indexOfParentList="colIdx"
                    :isDesign="isDesign" :formData="formData" :colHeight="widget.options.colHeight">
                </grid-col-widget>
            </template>
        </a-row>
    </container-wrapper>
</template>

<script setup>
import ContainerWrapper from "./container-wrapper.vue";
import GridColWidget from "./grid-col-widget.vue"
import { ref, toRefs, computed, inject } from 'vue';

const props = defineProps({
    widget: Object,
    isDesign: Boolean,
    widgetList: Array,
    indexOfParentList: Number,
    formData: Object,
})
const { widget, isDesign, widgetList, indexOfParentList } = toRefs(props)
const { updateSelectWidget } = inject("designer")
const layoutProps = computed(() => {
    return {
        gutter: widget.value.options.gutter || 0,
        align: 'top',
        justify: 'start',
        wrap: true,
    }
})

const selectWidget = (widget) => {
    if (!!isDesign.value) {
        updateSelectWidget(widget)
    }
}
</script>

<style lang="scss" scoped>
.grid-container {
    padding: 0 0 0 6px;
    align-items: unset !important;
}

.grid-container-design {
    margin-bottom: 10px;

    .grid-container {
        padding: 5px 10px;
    }
}
</style>